<!--
 * @Desc: 大屏展示
 * @Author: wanglidong 王立冬
 * @Date: 2023-05-22 08:07:53
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-23 10:04:57
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="largeScreen">
        <img
            class="icon-title"
            src="../../assets/images/largeScreen/icon-title.png"
        />
        <!-- 头部列表 -->
        <section class="head">
            <div class="head-item">
                <img class="thu" src="../../assets/images/largeScreen/1.png" />
                <div class="head-info">
                    <div class="title">今日新增</div>
                    <div class="num">1600</div>
                </div>
            </div>
            <div class="head-item">
                <img class="thu" src="../../assets/images/largeScreen/2.png" />
                <div class="head-info">
                    <div class="title">正名和恢复名誉人<br />(红榜）</div>
                    <div class="num">1600</div>
                </div>
            </div>
            <div class="head-item">
                <img class="thu" src="../../assets/images/largeScreen/3.png" />
                <div class="head-info">
                    <div class="title">处理人次<br />(黑榜）</div>
                    <div class="num">1600</div>
                </div>
            </div>
            <div class="head-item">
                <img class="thu" src="../../assets/images/largeScreen/4.png" />
                <div class="head-info">
                    <div class="title">
                        非法上访对多次、不合<br />理诉求列入打击（橙榜)
                    </div>
                    <div class="num">1600</div>
                </div>
            </div>
            <div class="head-item">
                <img class="thu" src="../../assets/images/largeScreen/5.png" />
                <div class="head-info">
                    <div class="title">
                        督办涵被多次下达<br />的所队（黄榜）
                    </div>
                    <div class="num">1600</div>
                </div>
            </div>
            <div class="head-item">
                <img class="thu" src="../../assets/images/largeScreen/6.png" />
                <div class="head-info">
                    <div class="title">有进京信访隐患的<br />(蓝榜）</div>
                    <div class="num">1600</div>
                </div>
            </div>
            <div class="head-item">
                <img class="thu" src="../../assets/images/largeScreen/7.png" />
                <div class="head-info">
                    <div class="title">
                        有进京信访隐患<br />后降风险列入（蓝榜）
                    </div>
                    <div class="num">1600</div>
                </div>
            </div>
        </section>
        <!-- 主体视觉 -->
        <section class="main-contain">
            <div class="main-item">
                <h1 class="title">总案件数</h1>
                234 <span>件</span>
            </div>
            <div class="main-item">
                <h1 class="title">办结案件数</h1>
                234 <span>件</span>
            </div>
            <div class="main-item">
                <h1 class="title">在办案件数</h1>
                234 <span>件</span>
            </div>
            <div class="main-item">
                <h1 class="title">息诉案件数</h1>
                234 <span>件</span>
            </div>
        </section>
        <!-- 在办案件 处理人员 -->
        <section class="progress-case-people">
            <div class="con-title">在办案件</div>
            <div class="people-body">
                <div class="body-head">
                    案件
                    <p>处理人员</p>
                </div>
                <div class="people-item" v-for="i in 7">
                    <div class="adress">郑口派出所执法不严</div>
                    <div class="name">戴友明</div>
                </div>
            </div>
        </section>
        <!-- 案件来源比例统计 -->
        <section class="source-case">
            <div class="con-title">案件来源比例统计</div>
            <div class="source-body">
                <div id="sourceBili" style="width: 100%; height: 100%" />
            </div>
        </section>
        <!-- 在办案件 -->
        <section class="progress-case">
            <div class="con-title">在办案件</div>
            <div class="progress-body">
                <div id="progress-case" style="width: 100%; height: 100%" />
            </div>
        </section>
        <!-- 各单位被处理人员比例 -->
        <section class="chuli-bili">
            <div class="con-title">各单位被处理人员比例</div>
            <div class="chuli-body">
                <div id="chuli-bili" style="width: 100%; height: 100%" />
            </div>
        </section>
        <!-- 问题类别比例统计 -->
        <section class="problem-tongji">
            <div class="con-title">问题类别比例统计</div>
            <div class="problem-body">
                <div id="problem-tongji" style="width: 100%; height: 100%" />
            </div>
        </section>
        <!-- 案件数据每月数据 -->
        <section class="moon-data">
            <div class="con-title">案件数据每月数据</div>
            <div class="moon-body">
                <div id="moon-data" style="width: 100%; height: 100%" />
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "Login",
    components: {},
    data() {
        return {
            loginForm: {
                username: "",
                password: "",
            },
        };
    },
    watch: {
        $route: {
            handler: function (route) {},
            immediate: true,
        },
    },
    created() {},
    mounted() {
        // 案件来源比例
        this.initChartsource();
        // 在办案件
        this.initChartprogress();
        // 问题类别比例统计
        this.initChartproblem();
        // 案件数据每月数据
        this.initChartmoon();
        // 各单位被处理人员比例
        this.initChartchuli();
    },
    destroyed() {},
    methods: {
        // 案件来源比例
        initChartsource() {
            const sourceChart = echarts.init(
                document.getElementById("sourceBili")
            );
            let data = [
                { value: 1048, name: "12345转办\n40%" },
                { value: 735, name: "群众来信\n32%" },
                { value: 580, name: "市局转办\n28%" },
            ];
            let option;
            option = {
                title: {
                    text: "总计\n200件",
                    subtext: "",
                    left: "center",
                    top: "center",
                    textStyle: {
                        color: "#fff",
                    },
                },
                color: ["#0095FF", "#00FFFF", "#00FFBF"],
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "vertical",
                    left: "center",
                    top: "100%",
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: ["50%", "70%"],
                        data: data.map((item, index) => {
                            item.label = {
                                color: "#fff",
                            };
                            return item;
                        }),
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };
            option && sourceChart.setOption(option);
        },
        // 在办案件
        initChartprogress() {
            const sourceChart = echarts.init(
                document.getElementById("progress-case")
            );
            let option;
            option = {
                dataset: {
                    source: [
                        ["amount", "product"],
                        [10, "三朗所"],
                        [30, "房庄所"],
                        [40, "辛庄所"],
                        [42, "里老所"],
                        [45, "夏庄所"],
                        [50, "青罕所"],
                        [70, "故城所"],
                        [77, "郑口所"],
                    ],
                },
                grid: { containLabel: true },
                xAxis: {
                    name: "",
                    axisLine: {
                        lineStyle: {
                            color: "#fff",
                        },
                    },
                    splitLine: {
                        //网格线
                        lineStyle: {
                            type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
                            color: "rgba(178, 194, 211, 0.3)",
                        },
                        show: true, //隐藏或显示
                    },
                },
                yAxis: {
                    type: "category",
                    axisLine: {
                        lineStyle: {
                            color: "#fff",
                        },
                    },
                },
                grid: {
                    // 让图表占满容器
                    top: "15%",
                    left: "20%",
                    right: "15%",
                    bottom: "15%",
                },
                series: [
                    {
                        itemStyle: {
                            color: function (params) {
                                let colorList = [
                                    "#7E96BA",
                                    "#7E96BA",
                                    "#7E96BA",
                                    "#7E96BA",
                                    "#7E96BA",
                                    "#CFA064",
                                    "#5046B1",
                                    "#4494E8",
                                ];
                                return colorList[params.dataIndex];
                            },
                        },
                        type: "bar",
                        label: {
                            show: true, // 开启显示
                            distance: 20, // 条柱之间的距离
                            position: "right", // 在上方top在右侧right显示
                            textStyle: {
                                // 数值样式
                                color: "#fff",
                                fontSize: 12,
                            },
                        },
                        encode: {
                            // Map the "amount" column to X axis.
                            x: "amount",
                            // Map the "product" column to Y axis
                            y: "product",
                        },
                    },
                ],
            };
            option && sourceChart.setOption(option);
        },
        // 问题类别比例统计
        initChartproblem() {
            const problemChart = echarts.init(
                document.getElementById("problem-tongji")
            );
            let option;
            option = {
                xAxis: {
                    type: "category",
                    data: ["案件办理类", "为民服务类", "纪律作风类"],
                    name: "",
                    axisLine: {
                        lineStyle: {
                            color: "#fff",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#fff",
                        },
                    },
                    splitLine: {
                        //网格线
                        lineStyle: {
                            type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
                            color: "rgba(178, 194, 211, 0.3)",
                        },
                        show: true, //隐藏或显示
                    },
                },
                grid: {
                    // 让图表占满容器
                    top: "15%",
                    left: "20%",
                    right: "15%",
                    bottom: "15%",
                },
                series: [
                    {
                        data: [120, 200, 150],
                        type: "bar",
                        barWidth: "20",
                        showBackground: true,
                        backgroundStyle: {
                            color: "rgba(187,230,245,0.22)",
                        },
                    },
                ],
            };
            option && problemChart.setOption(option);
        },
        // 案件数据每月数据
        initChartmoon() {
            const moonChart = echarts.init(
                document.getElementById("moon-data")
            );
            let option;
            option = {
                // color: ['#0091F9','#FFFFFF'],
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月"],
                    axisLine: {
                        lineStyle: {
                            color: "#fff",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#fff",
                        },
                    },
                    splitLine: {
                        //网格线
                        lineStyle: {
                            type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
                            color: "rgba(178, 194, 211, 0.3)",
                        },
                        show: true, //隐藏或显示
                    },
                },
                grid: {
                    // 让图表占满容器
                    top: "20%",
                    left: "20%",
                    right: "15%",
                    bottom: "20%",
                },
                series: [
                    {
                        data: [10, 20, 8, 40, 30, 20, 24],
                        type: "line",
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 0,
                                        color: "rgb(0,145,249,0.4)",
                                    },
                                    {
                                        offset: 1,
                                        color: "rgb(0,145,249,0)",
                                    },
                                ]
                            ),
                        },
                        smooth: true,
                        lineStyle: {
                            width: 2,
                            color: "#0795F7",
                        },
                        showSymbol: false,
                    },
                ],
            };
            option && moonChart.setOption(option);
        },
        // 各单位被处理人员比例
        initChartchuli() {
            const chuliChart = echarts.init(
                document.getElementById("chuli-bili")
            );
            let option;
            option = {
                title: {
                    text: "总人数\n2,845",
                    subtext: "",
                    left: "center",
                    top: "center",
                    textStyle: {
                        color: "#fff",
                    },
                },
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    top: "80%",
                    left: "center",
                    textStyle: {
                        color: "#fff",
                    },
                },
                series: [
                    {
                        name: "Access From",
                        type: "pie",
                        radius: ["30%", "50%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "top",
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 40,
                                fontWeight: "bold",
                            },
                        },
                        labelLine: {
                            show: false,
                        },
                        data: [
                            { value: 249, name: "郑口所\n249人" },
                            { value: 249, name: "里老所\n249人" },
                            { value: 249, name: "故城所\n249人" },
                            { value: 249, name: "辛庄所\n249人" },
                            { value: 249, name: "青罕镇所\n249人" },
                            { value: 249, name: "房庄所\n249人" },
                            { value: 249, name: "夏庄镇所\n249人" },
                            { value: 249, name: "三朗所\n249人" },
                        ],
                    },
                ],
            };
            option && chuliChart.setOption(option);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./reset.css";
@import "./index.scss";
</style>
